// School Logos
export const schoolLogos = {
    esprit: '/assets/schools/esprit.jpg',
    '3il': '/assets/schools/3iL.jpg',
    iset: '/assets/schools/iset-logo.png',
    insat: '/assets/schools/insat-logo.png',
    ensi: '/assets/schools/ensi-logo.png',
    supcom: '/assets/schools/supcom-logo.png',
    lts: '/assets/schools/lts.jpg',
    // Add more school logos as needed

    // SVG fallback for missing logos
    fallback: `data:image/svg+xml;base64,${btoa(`
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <rect width="100" height="100" fill="#0d0d0d" stroke="#732424" stroke-width="2"/>
            <text x="50" y="35" text-anchor="middle" fill="#d92323" font-family="Arial" font-size="12" font-weight="bold">SCHOOL</text>
            <text x="50" y="55" text-anchor="middle" fill="#7b7b7b" font-family="Arial" font-size="10">LOGO</text>
            <circle cx="50" cy="70" r="8" fill="none" stroke="#d92323" stroke-width="2"/>
            <path d="M46 70 L48 72 L54 66" stroke="#d92323" stroke-width="2" fill="none"/>
        </svg>
    `)}`
};